import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ImageFile} from '../../../../models/image-file';
import {CampaignService} from '../../../services/campaign/campaign.service';
import {TranslateService} from '@ngx-translate/core';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {saveAs as saveAs} from 'file-saver';

export enum FileAction {
  ADD = 'add',
  DELETE = 'delete'
}
@Component({
  selector: 'upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent {
  @Input()
  files: ImageFile[];
  @Input()
  isReadOnly: boolean;
  @Output()
  fileChanged = new EventEmitter<any>();
  @Output()
  public fileRemoved =  new EventEmitter<any>();
  @ViewChild('WarningErrorUploadFile')
  warningErrorUploadFile: AchooPopupComponent;

  enableUpload = true;
  public validationMsg: string;

  constructor(private campaignService: CampaignService,
              private translate: TranslateService,
              private modalService: ModalService) { }

  removeFile(fileId) {
    if (!this.files) {
      return;
    }
    const match = this.files.find(x => x.id === fileId);
    match.action = FileAction.DELETE;
    // this.files = this.files.filter(file => file.id !== fileId);
    // this.fileChanged.emit(this);
  }

  get availableFiles() {
    return this.files.filter((file) => file.action !== FileAction.DELETE);
  }

  onMaterialFileSelected(evt: Event) {
    if (!evt || !evt.target || !(<any>evt.target).files) {
      return;
    }
    const fileList = <FileList>((<any>evt.target).files);
    if (!fileList.length) {
      return;
    }
    const fileToUpload = fileList[0];
    try {
      this.campaignService.validateMaterialUploadFile(fileToUpload);
      // Only upload one file on each select
      const formData = new FormData();
      formData.append('file', fileToUpload);

      // Temporary disable upload
      this.enableUpload = false;
      this.campaignService.uploadFile(formData).subscribe(data => {
        data.content = data.diskFileName;
        data.action = FileAction.ADD;
        data.fileSize = fileToUpload.size;
        this.files.push(data);

        this.enableUpload = true;
        this.fileChanged.emit(this);
      });
    } catch (e) {
      this.validationMsg = this.translate.instant(e.message);
      this.modalService.open(this.warningErrorUploadFile, undefined, true);
    }
  }

  downloadFile(fileData) {
    this.campaignService.downloadCampaignMaterials(fileData).subscribe(data => {
      if (!data) {
        return;
      } else {
        saveAs(data, fileData.name);
      }
    });
  }

  isLastLine(index) {
    const numOfUploadedFile = this.files.length;
    if (numOfUploadedFile % 2 === 0) {
      return index === numOfUploadedFile - 1 || index === numOfUploadedFile - 2;
    } else {
      return index === numOfUploadedFile - 1;
    }
  }

  isOddLine(index) {
    return index % 2 !== 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/upload-file/upload-file.component.ts